// Libs
import React from "react";
import { Table } from "antd";
import { useNavigate, useParams } from "react-router-dom";

// Styles
import s from "./index.module.scss";

// Hooks
import { useSDKFirewallDestinationManageLink } from "hooks/manage-link-sdk";

// Components
import { FirewallDeviceManageLinkColumns } from "./utils";
import FirewallDestinationDetails from "components/libs/firewall-details";
import PageHeader from "components/libs/page-header";

function DashboardContentsFirewallDestinationManageLink() {
  const navigate = useNavigate();
  const params = useParams();

  //#region Data Hooks
  const {
    data: firewallDetails,
    onLink,
    onUnlink,
    loading,
  } = useSDKFirewallDestinationManageLink({
    tenantName: params.tenant,
    id: params.firewallId,
    timezone: "",
  });
  //#endregion

  //#region Columns
  const selectedColumns = FirewallDeviceManageLinkColumns({
    status: "selected",
    onLink: (id) => onUnlink({ deviceId: id }),
  });
  const availableColumns = FirewallDeviceManageLinkColumns({
    status: "available",
    onLink: (id) => onLink({ deviceId: id }),
  });
  //#endregion

  return (
    <>
      <PageHeader
        title="Manage Firewall Link"
        className={s.header}
        onBack={() => navigate(-1)}
      />
      {firewallDetails && (
        <>
          <section>
            <FirewallDestinationDetails
              firewallDetails={firewallDetails}
              loading={loading}
            />
          </section>

          <section className={s.section}>
            <h1 className={s.title}>Linked Device</h1>
            <Table
              columns={selectedColumns}
              dataSource={firewallDetails.selectedDevices}
              scroll={{ x: 1200 }}
              tableLayout="auto"
              loading={loading}
            />
          </section>

          <section className={s.section}>
            <h1 className={s.title}>Device Available for Linking</h1>
            <Table
              columns={availableColumns}
              dataSource={firewallDetails.availableDevices}
              scroll={{ x: 1200 }}
              tableLayout="auto"
              loading={loading}
            />
          </section>
        </>
      )}
    </>
  );
}

export default DashboardContentsFirewallDestinationManageLink;
